import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'

import { GlgIcon } from 'SharedComponents'

class AdvancedFiltersToggle extends PureComponent {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange() {
    if (!this.props.disabled) {
      this.props.onChange('advancedFiltersOn', !this.props.open)
    }
  }
  render() {
    const icon = `${ this.props.open ? 'less' : 'more' }-with-symbol`
    const iconClass = `${ this.props.open ? 'less' : 'more' }-toggle ${ this.props.disabled ? '' : 'clickable' }`
    return (
      <Row center="xs" className="advanced-filters-toggle">
        <Col xs={true}>
          <GlgIcon icon={ icon } iconClass={ iconClass }
                   onClick={ this.handleChange } />
        </Col>
      </Row>
    )
  }
}

AdvancedFiltersToggle.propTypes = {
  open: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
}

export default AdvancedFiltersToggle
